import { isNumber } from 'lodash';

const formatGranelSimulation = (fields) => {
  const homologationVC = fields?.fabricaVC?.homologationVC ? fields?.fabricaVC?.homologationVC.toString().replace(' ', '').replace(',', '.') : 0.0;
  const homologationCompetitor = fields?.concorrente?.homologationCompetitor ? fields?.concorrente?.homologationCompetitor.toString().replace(' ', '').replace(',', '.') : 0.0;
  const consumptionFob = fields?.cliente?.consumptionFob ? fields?.cliente?.consumptionFob.toString().replace(',', '.') : 0;
  const consumptionCif = fields?.cliente?.consumptionCif ? fields?.cliente?.consumptionCif.toString().replace(',', '.') : 0;

  const formatedFields = {
    Id: fields.resultados.simulationId,
    CustomerId: fields.cliente.customerId || null,
    CustomerName: fields.cliente.name || fields.cliente.corporateName,
    CodeSegment: fields.cliente.segment.toString(),
    UF: fields.cliente.uf?.value?.toString() || fields.cliente.uf?.toString(),
    City: fields.cliente.cidade?.value?.toString() || fields.cliente.cidade?.toString(),
    CompetitorFactoryMaterialId:
      fields.concorrente.factoryMaterialId ? fields.concorrente.factoryMaterialId : null,
    VCFactoryMaterialId: fields.fabricaVC.factoryMaterialId,
    SegmentId: fields.cliente.segment,
    SpontaneousCustomerInfo: fields.spontaneousCustomerInfo ?? false,
    Type: fields?.cliente?.type ?? 1,
    Reason: fields?.cliente?.reason ?? 1,
    ReasonId: fields?.cliente?.reason ?? 1,
    TaxBenefit: fields.cliente.taxBenefit || null,
    DistanceFactoryVC: fields.distanceFactoryVC,
    DistanceFactoryCompetitor: fields.distanceFactoryCompetitor,
    HomologationVC: parseFloat(homologationVC) || 0.0,
    HomologationCompetitor: parseFloat(homologationCompetitor) || 0.0,
    HomeAccountId: fields?.homeAccountId,
    specialDiscount: (fields?.cicons?.specialDiscount || 0),
    EmployeeName: (fields?.user?.displayName || null),
    SellerCode: (fields?.user?.employeeId || null),
    ConsumptionFob: parseFloat(consumptionFob) || 0,
    ConsumptionCif: parseFloat(consumptionCif) || 0,
    VCPriceFob: fields?.fabricaVC?.priceVCFob || 0,
    VCPriceCif: fields?.fabricaVC?.priceVCCif || 0,
    VCArbitratedFreigth: fields?.fabricaVC?.arbitrattedVCFreigth || 0,
    competitorPriceFob: fields?.concorrente?.priceFob || 0,
    competitorPriceCif: fields?.concorrente?.priceCif || 0,
    competitorArbitratedFreigth: fields?.concorrente?.arbitratedFreigth || 0,
    mapaMinaConcorrente: {
      playerPriceFOB: isNumber(fields?.concorrente?.mapaMina?.playerFob)
        ? fields?.concorrente?.mapaMina?.playerFob
        : null,
      playerPriceCIF: isNumber(fields?.concorrente?.mapaMina?.playerCif)
        ? fields?.concorrente?.mapaMina?.playerCif
        : null,
      marketPriceFOB: isNumber(fields?.concorrente?.mapaMina?.mercadoFob)
        ? fields?.concorrente?.mapaMina?.mercadoFob
        : null,
      marketPriceCIF: isNumber(fields?.concorrente?.mapaMina?.mercadoCif)
        ? fields?.concorrente?.mapaMina?.mercadoCif
        : null,
    },
    mapaMinaVC: {
      playerPriceFOB: isNumber(fields?.fabricaVC?.mapaMina?.playerFob)
        ? fields?.fabricaVC?.mapaMina?.playerFob
        : null,
      playerPriceCIF: isNumber(fields?.fabricaVC?.mapaMina?.playerCif)
        ? fields?.fabricaVC?.mapaMina?.playerCif
        : null,
      marketPriceFOB: isNumber(fields?.fabricaVC?.mapaMina?.mercadoFob)
        ? fields?.fabricaVC?.mapaMina?.mercadoFob
        : null,
      marketPriceCIF: isNumber(fields?.fabricaVC?.mapaMina?.mercadoCif)
        ? fields?.fabricaVC?.mapaMina?.mercadoCif
        : null,
    },
    kaMasterVC: {
      kaPriceFOB: isNumber(fields?.fabricaVC?.kaMaster?.kaPriceFOB)
        ? fields?.fabricaVC?.kaMaster?.kaPriceFOB
        : null,
      kaPriceCIF: isNumber(fields?.fabricaVC?.kaMaster?.kaPriceCIF)
        ? fields?.fabricaVC?.kaMaster?.kaPriceCIF
        : null,
      masterPriceFOB: isNumber(fields?.fabricaVC?.kaMaster?.masterPriceFOB)
        ? fields?.fabricaVC?.kaMaster?.masterPriceFOB
        : null,
      masterPriceCIF: isNumber(fields?.fabricaVC?.kaMaster?.masterPriceCIF)
        ? fields?.fabricaVC?.kaMaster?.masterPriceCIF
        : null,
    },
  };

  return formatedFields;
};

export default formatGranelSimulation;
